import { FC, useState } from 'react';
import Modal from '@components/Modal/Modal';
import createModalMount from '@functions/createReactModalMount';
import closeModal from '@functions/closeReactModal';
import { createRoot } from 'react-dom/client';
import SubscribeForm from '@forms/SubscribeForm/SubscribeForm';
import { getCookie } from 'typescript-cookie';
import ModalMount from '@type/ModalMount';
import cx from 'classnames';
import ModalContent from '@layouts/SubscribeFormModal/SubscribeFormModal';

const subscribeForm = document.getElementById('subscribe-form') as HTMLDivElement;
const subscribeTriggers = Array.from(
    document.querySelectorAll('[data-form-trigger="subscribe"]')
) as HTMLButtonElement[];
const subscribeBanner = document.querySelector('.section--subscribe-top-banner') as HTMLDivElement;
const bannerCloseBtn = document.querySelector('.section--subscribe-top-banner .btn-close') as HTMLButtonElement;

const SubscribeFormModal: FC<ModalMount> = ({ mount, root }) => {
    const [open, setOpen] = useState(true);

    return (
        <Modal
            isOpen={open}
            className={cx(
                'tw-w-full lg:tw-max-h-[608px] lg:tw-max-w-[946px] xl:!tw-border-0 xl:!tw-pb-0 xl:!tw-pl-0 xl:tw-pt-0'
            )}
            headerClassName={cx('xl:!tw-absolute xl:!tw-w-full xl:!tw-pt-3')}
            contentClassName={cx('lg:tw-h-full lg:!tw-overflow-hidden')}
            testId={'modal--subscribe-form'}
            onClose={() =>
                closeModal({
                    domElement: mount,
                    appRoot: root,
                    closeAction: setOpen,
                })
            }
            appElement={mount}
        >
            <ModalContent />
        </Modal>
    );
};

window.addEventListener('DOMContentLoaded', () => {
    if (subscribeBanner) {
        bannerCloseBtn.addEventListener('click', () => {
            subscribeBanner.style.display = 'none';
        });
    }
    if (subscribeBanner && getCookie('subscribeFormFilled') === undefined) {
        subscribeBanner.style.display = 'block';
        if (subscribeForm) {
            const subscribeFormRoot = createRoot(subscribeForm);
            subscribeFormRoot.render(<SubscribeForm />);
        }
    }

    subscribeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = createModalMount('subscribe-form-modal');
            const subscribeFormModalRoot = createRoot(modal);
            subscribeFormModalRoot.render(<SubscribeFormModal mount={modal} root={subscribeFormModalRoot} />);
        });
    });
});
